<!-- /* [NT-PF-READ-P-POP] 프로필보기(개인) */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="프로필 보기"
      v-if="data"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <UserInfoCard :data="data" />

        <div>
          <h6 class="popupViewProfileHeadline">회원 정보</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">아이디</td>
                <td>{{ data.id }}</td>
              </tr>
              <tr>
                <td class="firstTd">생년월일</td>
                <td>{{ data.birthday }}</td>
              </tr>
              <tr>
                <td class="firstTd">구분</td>
                <td>
                  <template
                    v-if="
                      data.classification &&
                        ['1', '2', '3'].includes(data.classification)
                    "
                  >
                    {{
                      lodash.find(userClassification, function(o) {
                        return o.value == data.classification;
                      }).text
                    }}
                  </template>
                </td>
              </tr>
              <tr>
                <td class="firstTd">지역</td>
                <td>{{ data.address }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">학력</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">최종학력</td>
                <td>
                  <template
                    v-if="data.education && ['1', '2'].includes(data.education)"
                  >
                    {{
                      lodash.find(sidoList, function(o) {
                        return o.value == data.education;
                      }).text
                    }}
                  </template>
                </td>
              </tr>
              <tr>
                <td class="firstTd">최종학교명</td>
                <td>{{ data.school }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">경력 정보</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr v-for="(item, index) in careers" :key="index">
                <td class="firstTd">
                  {{ item.careerPeriodFrom }}
                  <template v-if="item.inOffice == 1">
                    ~ 현재
                  </template>
                  <template v-else>
                    <br />
                    <div style="text-align: right">
                      ~ {{ item.careerPeriodTo }}
                    </div>
                  </template>
                </td>
                <td>{{ item.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">자기소개</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">나의 소개</td>
                <td>
                  {{ data.aboutMe }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망분야</h6>
          <table
            v-for="(item, index) in industries1"
            :key="index"
            :style="index > 0 ? 'margin-top: 12px;' : ''"
            class="popupViewProfileTable"
          >
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">{{ index + 1 }}</td>
                <td class="firstTd">산업</td>
                <td>{{ item.text }}</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>
                  <div v-for="(subItem, index2) in item.sub" :key="index2">
                    {{ subItem.text }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망활동</h6>
          <table
            v-for="(item, index) in activities"
            :key="index"
            :style="index > 0 ? 'margin-top: 12px;' : ''"
            class="popupViewProfileTable"
          >
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">{{ index + 1 }}</td>
                <td class="firstTd">희망 분야</td>
                <td>{{ item.text }}</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>{{ item.content }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template #footer>
        <div style="display: flex; align-items: center; gap: 1rem;">
          <template v-if="user.roleName == 'ROLE_ADMIN'">
            <MainButton
              btnText="닫기"
              width="191px"
              color="gray"
              fontSize="2rem"
              customHeight="53px"
              @click="handleToggleModal"
            />
          </template>
          <template v-else>
            <MainButton
              btnText="네트워킹 신청 하기"
              customHeight="53px"
              fontSize="2rem"
              @click="handleOk(data)"
            />
            <button
              style="border: 1px solid #989898; background-color: #fff; height: 53px; width: 191px;  font-size: 2rem;"
              @click="handleToggleModal"
            >
              닫기
            </button>
          </template>
        </div>
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import {
  ageFriendlyIndustry,
  hopeActivity,
  sidoList,
  userClassification,
} from "@/data/constances";
import UserInfoCard from "@/components/items/UserInfoCard.vue";

export default {
  name: "PopupViewProfilePersonal",
  components: { BasicModal, MainButton, UserInfoCard },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    handleOk: Function,
    data: Object,
  },
  computed: {
    industries1() {
      if (
        this.data?.industries1 == "null" ||
        this.lodash.isEmpty(this.data?.industries1)
      )
        return [];
      let item = JSON.parse(this.data?.industries1 || "[]");
      return (
        item
          .map((item) => {
            let obj = ageFriendlyIndustry.find(
              (temp) => temp.value == item.categoryIndustryId,
            );
            if (!obj) return null;

            let sub = item.categoryIds
              .map((subItem) => {
                let tmp = obj.sectors.find((a) => a.value == subItem);
                return tmp;
              })
              ?.filter((e) => e != null);
            return {
              ...item,
              sub,
              text: obj.name,
            };
          })
          ?.filter((item) => item !== null) || []
      );
    },
    activities() {
      if (
        this.data?.activities == "null" ||
        this.lodash.isEmpty(this.data?.activities)
      )
        return [];
      let item = JSON.parse(this.data?.activities || "[]");
      return (
        item
          .map((activity) => {
            let item = hopeActivity.find((a) => a.value == activity.activityId);
            if (!item) return null;
            return {
              ...activity,
              text: item.name,
            };
          })
          ?.filter((item) => item !== null) || []
      );
    },
    careers() {
      if (
        this.data?.careers == "null" ||
        this.lodash.isEmpty(this.data?.careers)
      )
        return [];
      return JSON.parse(this.data?.careers || "[]");
    },
  },
  data() {
    return {
      userClassification,
      sidoList,
      user: this.$store.state.auth.user,
    };
  },
  methods: {
    // onClickSubmitForm() { }
  },
};
</script>

<style lang="scss" scoped></style>
